import Table from "react-bootstrap/Table";
import "../../../assets/css/downloadButton.css";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { stripeCustomerTransactions } from "../../../Redux/Stripe/action";

const Invoices = () => {
  const dispatch = useDispatch();
  const paymentData = useSelector((state) => state.authReducer.paymentData);
  const [paymentIntents, setPaymentIntents] = useState([]);
  const customerTransactionsByIdSuccess = useSelector(
    (state) => state.stripeReducer.customerTransactionsByIdSuccess,
  );
  useEffect(() => {
    const fetchData = async () => {
      if (paymentData) {
        try {
          await stripeCustomerTransactions(dispatch, paymentData?.customerID);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    };

    fetchData();
  }, [paymentData]);
  useEffect(() => {
    if (customerTransactionsByIdSuccess) {
      setPaymentIntents(customerTransactionsByIdSuccess);
    }
  }, [customerTransactionsByIdSuccess]);
  function formatCurrency(amount) {
    const formattedAmount = (amount / 100).toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
    return formattedAmount;
  }
  function capitalizeFirstLetter(str) {
    return str.replace(/\b\w/g, (match) => match.toUpperCase());
  }

  return (
    <>
      {paymentIntents?.data?.length > 0 ? (
        <>
          <Table>
            <thead>
              <tr className={"custom-style-settings-menu-bold"}>
                <th>Date</th>
                <th>Amount</th>
                <th>Details</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {paymentIntents?.data.map((invoice, index) => (
                <tr key={index}>
                  <td>
                    {new Date(invoice.created * 1000).toLocaleDateString()}
                  </td>
                  <td>{formatCurrency(invoice.amount_received)}</td>
                  <td>
                    {capitalizeFirstLetter(
                      invoice.description.replace(/_/g, " "),
                    )}
                  </td>
                  <td
                    style={{
                      fontWeight: "bolder",
                      color: invoice.status === "succeeded" ? "green" : "red",
                    }}
                  >
                    {capitalizeFirstLetter(invoice.status.replace(/_/g, " "))}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </>
      ) : (
        <>
          <div className="loader-invoices">
            <div className="wrapper">
              <div className="circle"></div>
              <div className="line-1"></div>
              <div className="line-2"></div>
              <div className="line-3"></div>
              <div className="line-4"></div>
              <div className="line-5"></div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Invoices;
